import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'showtimeonly'
})
export class ShowTimeOnlyPipe implements PipeTransform{


    transform(value: string,args?: any) {
        
        var pos = value.indexOf('T');
        var res = value.substr(pos+1,5);
        return res
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Pipes/showTimeOnly.pipe.ts